<template>
  <div class="d-block">
    <v-text-field
      v-model="searchQuery"
      @keyup.enter="search(searchQuery)"
      label="O que você está procurando hoje?"
      block solo outlined rounded hide-details
      @focus="searchHistoryActive = true"
      @blur="hideSearchHistory"
      :dense="$vuetify.breakpoint.xs"
    >
      <template #append>
        <v-btn
          icon
          class="ma-0 pa-0"
          @click="search(searchQuery)"
          @keyup.enter="search(searchQuery)"
        >
          <v-icon>mdi-magnify </v-icon>
        </v-btn>
      </template>
    </v-text-field>
    <div style="height: 0; width: 100%">
      <v-expand-transition>
        <v-card
          elevation="4"
          class="mx-8"
          style="z-index: 10; max-height: 200px; overflow: hidden"
          v-if="searchHistoryActive && filteredSearched.length > 0"
        >
          <v-list>
            <template v-for="(query, i) in filteredSearched">
              <v-list-item :key="i" @click="searchQuery = query.title" dense>
                <v-list-item-content>
                  {{ query.title }}
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
      </v-expand-transition>
    </div>
  </div>
</template>

<script>
const STORAGE_KEY = "searchedHistory";
export default {
  data: () => ({
    searchQuery: "",
    searchHistoryActive: false,
    searchHistory: [],
  }),
  created() {
    this.searchHistory = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  },
  computed: {
    filteredSearched() {
      return this.searchHistory.filter((query) => {
        return query.title.toLowerCase().match(this.searchQuery.toLowerCase());
      });
    },
  },
  methods: {
    hideSearchHistory() {
      setTimeout(() => {
        this.searchHistoryActive = false;
      }, 100);
    },
    search(search) {
      if (search.length > 0)
      this.$router.push({
        path: "/busca/" + search,
        params: {
          query: this.searchQuery,
        },
      });
      if (this.searchQuery) {
        this.searchHistory.unshift({
          title: this.searchQuery,
          completed: "false",
          id: 1,
        });
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this.searchHistory));
        this.searchQuery = "";
      }
    },
  },
};
</script>
